import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { getProfile } from '../store/slices/authSlice';
import { Spinner, Center } from '@chakra-ui/react';
import { scheduleTokenRefresh } from '../lib/api';

interface AuthInitializerProps {
  children: React.ReactNode;
}

export default function AuthInitializer({ children }: AuthInitializerProps) {
  const dispatch = useAppDispatch();
  const { accessToken, user } = useAppSelector((state) => state.auth);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const initAuth = async () => {
      if (accessToken && !user) {
        try {
          await dispatch(getProfile()).unwrap();
        } catch (error) {
          console.error('Failed to fetch profile:', error);
        }
      }
      setInitialized(true);
    };

    initAuth();
  }, [dispatch, accessToken, user]);

  useEffect(() => {
    if (!accessToken) return;

    const cleanup = scheduleTokenRefresh();
    return () => {
      if (cleanup) cleanup();
    };
  }, [accessToken]);

  if (!initialized && accessToken && !user) {
    return (
      <Center h="100vh">
        <Spinner size="xl" color="blue.500" />
      </Center>
    );
  }

  return <>{children}</>;
}
